import { connect } from 'react-redux';
import Line from '../components/Line';

function findAltIds(state, lineId) {
  // Flatten out groups
  const ids = [].concat.apply(
    [],
    (state.song.lineGroups || [])
      // And filter out groups that don't contain lineId
      .filter(grp => grp.indexOf(lineId) >= 0),
  );

  // Make sure lineId is part of the items
  if (ids.indexOf(lineId) === -1) {
    ids.push(lineId);
  }

  return ids;
}

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  line: ownProps.line,
  // id: ownProps.id,
  // alt: groupLines(state, findAltIds(state, ownProps.line.id)),
  alt: findAltIds(state, ownProps.line.id).map(altId => state.song.lines.byId[altId]),
  // allLines: state.song.allLines,
  uiToggles: state.ui.toggles,
  onReplace: ownProps.onReplace,
  // selected: (state.ui.selectedItems.line || []).indexOf(ownProps.line.id) >= 0,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  // onSelect: () => dispatch(selectItem('line', ownProps.line.id)),
  // onToggleSelect: () => dispatch(toggleSelectedItem('line', ownProps.line.id)),
});

const LineContainer = connect(mapStateToProps, mapDispatchToProps)(Line);

export default LineContainer;



// WEBPACK FOOTER //
// ./src/containers/LineContainer.js